import _L from "../../../../util/Labels";
import { _ModalToAProccess } from "../../../controlD3/ModalThings/ModalToAProccess";
import { MEscuela } from "../../../../data/model/MEscuela";
import { NotificacionV2 } from "../../../controlD3/NotificacionV2";
import { RadarProximityConfig } from "../../../components-lit/RadarProximityConfig/RadarProximityConfig";
import { svEscuelaConfigurarRadarProximidad, svEscuelaObtenerConfiguracionProximidad } from "../../../../data/modulo/EscuelaProximidad";

export class EscuelaConfigurarRadarProximidad {
    private proximityConfigurator: RadarProximityConfig = null;

    constructor(
        private escuela: MEscuela
    ) {
        this.init();
    }

    private init() {
        const escuela = this.escuela;

        _ModalToAProccess({
            Title: _L("escuelas_proximidad.proximity_radar_cfg"),
            Width: 700,
            DrawContent: async (content, mt) => {
                let divContent = content.append("div");
                const latitudLongitudSchool = escuela.latitudLongitud;
                let latitudSchool = 0;
                let longitudSchool = 0;

                this.proximityConfigurator = new RadarProximityConfig();
                if (latitudLongitudSchool != null) {
                    latitudSchool = Number(latitudLongitudSchool.split(",")[0]);
                    longitudSchool = Number(latitudLongitudSchool.split(",")[1]);
                }

                this.proximityConfigurator.k_schoolLatitud = latitudSchool;
                this.proximityConfigurator.k_schoolLongitud = longitudSchool;
                this.proximityConfigurator.k_state = false;

                divContent.append(() => this.proximityConfigurator);

                mt.Progress.attr("oculto", false);
                const resRadarCfgRes = await svEscuelaObtenerConfiguracionProximidad(escuela.IdKinder);
                mt.Progress.attr("oculto", true);
                if (resRadarCfgRes.Resultado < 1) {
                    NotificacionV2._Mostrar(_L("general.notif_fail_infosync"), "ADVERTENCIA");
                }

                const config = resRadarCfgRes.Resultado < 1 ? null : resRadarCfgRes.Datos[0];
                if (config != null) {
                    this.proximityConfigurator.k_latitude = config.Latitud;
                    this.proximityConfigurator.k_longitude = config.Longitud;
                    this.proximityConfigurator.k_radioLlegada = config.RadioLlegada;
                    this.proximityConfigurator.k_radioZonaEscolar = config.RadioZonaEscolar;
                    this.proximityConfigurator.k_state = config.Estado === 1;
                } else {
                    this.proximityConfigurator.k_latitude = latitudSchool;
                    this.proximityConfigurator.k_longitude = longitudSchool;
                }
            },
            OnAccept: async () => {
                const lat = this.proximityConfigurator.k_latitude;
                const lng = this.proximityConfigurator.k_longitude;
                const radioLlegada = this.proximityConfigurator.k_radioLlegada;
                const radioZonaEscolar = this.proximityConfigurator.k_radioZonaEscolar;
                const status = this.proximityConfigurator.k_state ? 1 : 0;

                const resRadarProximidadCfg = await svEscuelaConfigurarRadarProximidad(
                    this.escuela.IdKinder,
                    status,
                    lat, lng, radioLlegada, radioZonaEscolar
                );

                return resRadarProximidadCfg;
            }
        })
    }
}